(() => {
  const root = document.body.dataset.root || '/';
  const pendingMessage = 'We couldn’t confirm whether the item was added. Check your bag before trying again.';
  const requestMessage = status => {
    if ([400, 404, 422].includes(status)) return 'This item or quantity is unavailable. Review your selection and try again.';
    if (status === 429) return 'The store is receiving too many requests. Wait a moment before trying again.';
    if (status === 401 || status === 403) return 'The store couldn’t accept this request. Refresh the page and try again.';
    return pendingMessage;
  };
  const validQuantity = input => /^\d+$/.test(input.value) && Number.isSafeInteger(Number(input.value)) && Number(input.value) >= Number(input.min || 0);
  function validateQuantity(input) {
    input.setCustomValidity(validQuantity(input) ? '' : 'Enter a whole-number quantity of ' + (input.min || 0) + ' or more.');
  }
  function init(scope = document) {
    scope.querySelectorAll('input[name="quantity"], input[name="updates[]"]').forEach(input => {
      if (input.dataset.validated) return;
      input.dataset.validated = 'true';
      input.addEventListener('input', () => validateQuantity(input));
      input.addEventListener('change', () => validateQuantity(input));
      input.form?.addEventListener('submit', event => {
        validateQuantity(input);
        if (!input.reportValidity()) event.preventDefault();
      });
    });
    scope.querySelectorAll('.contact-form:not([data-validated])').forEach(form => {
      form.dataset.validated = 'true';
      const fields = [...form.querySelectorAll('input:not([type="hidden"]), textarea')];
      const validate = field => {
        const label = field.labels?.[0]?.textContent || 'This field';
        let message = '';
        if (field.required && !field.value.trim()) message = label + ' cannot be blank.';
        else if (field.maxLength >= 0 && field.value.length > field.maxLength) message = 'Use ' + field.maxLength + ' characters or fewer.';
        field.setCustomValidity(message);
      };
      fields.forEach(field => field.addEventListener('input', () => validate(field)));
      form.addEventListener('submit', event => {
        fields.forEach(validate);
        if (!form.reportValidity()) event.preventDefault();
      });
    });
    scope.querySelectorAll('[data-product-root]:not([data-ready])').forEach(container => {
      container.dataset.ready = 'true';
      const form = container.querySelector('form');
      if (!form) return;
      const button = form.querySelector('[data-add-button]');
      const status = form.querySelector('[data-form-status]');
      const quantity = form.querySelector('[name="quantity"]');
      let variants;
      try {
        variants = JSON.parse(container.querySelector('[data-variants]').textContent);
        if (!Array.isArray(variants) || !variants.every(v => v && Number.isSafeInteger(v.id) && typeof v.available === 'boolean' && typeof v.price === 'string')) return;
      } catch { return; } // Keep the native Shopify form usable when enhancement data is unavailable.
      const select = form.querySelector('[data-variant-select]');
      let busy = false;
      const selected = () => variants.find(v => String(v.id) === select.value);
      function updateVariant() {
        const variant = selected();
        if (!variant) { button.disabled = true; return; }
        container.querySelector('[data-price]').textContent = variant.price;
        document.querySelectorAll('[data-sticky-price]').forEach(el => el.textContent = variant.price);
        button.disabled = !variant.available || busy;
        button.querySelector('span').textContent = variant.available ? 'Add to bag' : 'Sold out';
        status.textContent = '';
        if (document.body.classList.contains('template-product')) {
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        }
      }
      select.addEventListener('change', updateVariant);
      container.querySelectorAll('[data-quantity]').forEach(control => control.addEventListener('click', () => {
        const current = validQuantity(quantity) ? Number(quantity.value) : 1;
        const number = Math.max(1, Math.min(Number.MAX_SAFE_INTEGER, current + Number(control.dataset.quantity)));
        quantity.value = number; quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        validateQuantity(quantity);
        if (busy || !form.reportValidity() || !selected()?.available) return;
        busy = true; button.disabled = true; button.setAttribute('aria-busy', 'true');
        button.querySelector('span').textContent = 'Adding…'; status.classList.remove('is-error'); status.textContent = '';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let failureMessage = pendingMessage;
        try {
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) { failureMessage = requestMessage(response.status); throw new Error('Cart request rejected'); }
          const result = await response.json();
          if (!result || !Number.isSafeInteger(result.id) || !Number.isSafeInteger(result.quantity) || result.quantity < 1) throw new Error('Unexpected cart response');
          status.textContent = 'Added to your bag.';
          const link = document.createElement('a'); link.href = `${root}cart`; link.textContent = 'View bag'; status.append(link);
          // Adding succeeded even if the separate count refresh cannot complete.
          fetch(`${root}cart.js`, { signal: AbortSignal.timeout(10000) }).then(r => r.ok ? r.json() : null).then(cart => {
            if (cart && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
          }).catch(() => {});
        } catch {
          status.classList.add('is-error'); status.textContent = failureMessage;
          const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View bag'; status.append(link);
        } finally {
          clearTimeout(timeout);
          busy = false; button.removeAttribute('aria-busy'); button.disabled = !selected()?.available;
          button.querySelector('span').textContent = selected()?.available ? 'Add to bag' : 'Sold out';
        }
      });
    });
    scope.querySelectorAll('[data-gallery-image]:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const gallery = button.closest('.product-gallery'); const image = gallery.querySelector('.gallery-stage img');
        image.src = button.dataset.galleryImage; image.removeAttribute('srcset'); image.alt = button.dataset.galleryAlt;
        gallery.querySelectorAll('[aria-pressed]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      });
    });
    scope.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  // The mobile buy bar shows whenever no add-to-bag button is on screen, including before the visitor scrolls.
  const sticky = document.querySelector('[data-sticky-purchase]'); const buyRows = document.querySelectorAll('.purchase-row');
  if (sticky && buyRows.length && 'IntersectionObserver' in window) {
    const visibleRows = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visibleRows.add(entry.target) : visibleRows.delete(entry.target));
      sticky.hidden = visibleRows.size > 0;
    }, { rootMargin: '-85px 0px 0px 0px' });
    buyRows.forEach(row => observer.observe(row));
  }
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(el => { el.removeAttribute('open'); el.querySelector('summary').focus(); }); });
})();
